"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
///<reference path="../../../../typings/index.d.ts"/>
var l = require("lenovo");
$(function () {
    $('.global-home-detect .home-lsb-detect').on('click', function () {
        l.DTM.Lmd.unifiedCustomInteractionTrack("Product Family | PC");
        $('.global-home-detect .home-lsb-detect').prop('disabled', true);
        LSBV5.Dispatcher.addOnlyEventListener(LSBV5.EventTypeEnum.CloseInstallCallBack, LSBV5.ComponentTypeEnum.Detect, function (data) {
            $('.global-home-detect .home-lsb-detect').prop('disabled', false);
            console.log("LSBV5.EventTypeEnum.CloseInstallCallBack:", data);
        });
        LSBV5.Detect.run(function (data) {
            console.log('LSB Detect success');
            console.log(data);
            $('.global-home-detect .home-lsb-detect').html(l.Translator.translate('Redirecting'));
            $('.global-home-detect .home-lsb-detect').attr('t', 'Redirecting');
            l.Content.queryByKeywordsAsync(data.SN, function (product) {
                if (product && product.length && product.length > 0 && product[0].IsSupported === true && product[0].Name) {
                    l.DTM.push({
                        type: "eSupportProcess_Complete",
                        name: "LSB:SuccessfulMachineDetection",
                        action: "Button Click",
                        eSupportDeviceInfo: {
                            serialNumber: data.SN,
                            machineTypeModel: data.MTM
                        }
                    });
                    l.Redirect.toProductSupportPage(product[0].Id, "", {}, product[0].Serial);
                }
                else {
                    console.log('Cannot find product corresponding to SN ' + data.SN);
                    $('.global-home-detect .home-lsb-detect').prop('disabled', false);
                    $('.global-home-detect .home-lsb-detect').html(l.Translator.translate('detect your product|Detect Your Product'));
                    $('.global-home-detect .home-lsb-detect').attr('t', 'detect your product|Detect Your Product');
                }
            });
        }, function () {
        });
    });
    if (l.MobileDetectControl.mobileResource.mobile() && l.MobileDetectControl.mobileResource.tablet() == null) {
        $('.product-family').css("width", "100%");
        $('.product-family').parent('a').css("width", "100%");
        $('.product-family').children('a').children('img').css("width", "100%");
        $('.product-family').children('img').css("width", "100%");
        $('.product-family-child').css("width", "100%");
        var ChildHeight = $('.product-family').children('img').height();
        $('.product-family-child').css("height", ChildHeight);
    }
    if (l.MobileDetectControl.mobileResource.mobile()) {
        $('.product-family').on('click', function (e) {
            var $this = $(e.currentTarget);
            $this.children(".product-family-child").show();
            e.stopPropagation();
        });
        $(document).on('click', function () {
            $(".product-family-child:visible").hide();
        });
    }
    else {
        $('.product-family').on('mouseover', function (e) {
            var $this = $(e.currentTarget);
            $this.children('.product-family-child').show();
            $this.on('mouseleave', function (e) {
                var $this = $(e.currentTarget);
                $('.product-family-child').hide().off('mouseleave');
                $this.off('mouseleave');
            });
        });
    }
});
$(function () {
    if (window["lenovo-home-typeahead"]) {
        window["lenovo-home-typeahead"]($("#home-search").get(0));
    }
    ;
    var familymaxheight = $('.product-family-content').height();
    $('.product-family-content').each(function () {
        if ($(this).height() > familymaxheight) {
            familymaxheight = $(this).height();
        }
    });
    $('.product-family-content').css("height", familymaxheight + 15);
});
